import { combineReducers } from 'redux'

import entidades from './store'
import consultaBem from './consultaBem/store'
import consultaContrato from './consultaContrato/store'
import consultaContratoCovid from './consultaContratoCovid/store'
import consultaLicitacao from './consultaLicitacao/store'
import consultaLicitacaoCovid from './consultaLicitacaoCovid/store'
import detalhesContrato from './detalhesContrato/store'
import detalhesLicitacao from './detalhesLicitacao/store'
import consultaBensImoveis from './consultaBensImoveis/store'
import consultaPrestadoresServicosEmpresasTerceirizadas from './consultaPrestadoresServicosEmpresasTerceirizadas/store'
import consultaAtaRegistroPreco from './consultaAtaRegistroPreco/store'
import consultaAtaRegistroPrecoMP from './consultaAtaRegistroPrecoMP/store'
import detalhesAtaRegistroPreco from './detalhesAtaRegistroPreco/store'
import consultaAdvertenciaFornecedor from './consultaAdvertenciaFornecedor/store'
import detalhesAdvertenciaFornecedor from './detalhesAdvertenciaFornecedor/store'
import consultaListaObrasParadas from './consultaListaObrasParadas/store'
import detalhesObrasParadas from './detalhesObrasParadas/store'
import consultaObras from './consultaObras/store'

export default combineReducers({
    entidades,
    consultaBem,
    consultaContrato,
    consultaLicitacao,
    detalhesContrato,
    detalhesLicitacao,
    consultaBensImoveis,
    consultaLicitacaoCovid,
    consultaContratoCovid,
    consultaAtaRegistroPreco,
    consultaAtaRegistroPrecoMP,
    detalhesAtaRegistroPreco,
    consultaAdvertenciaFornecedor,
    detalhesAdvertenciaFornecedor,
    consultaListaObrasParadas,
    detalhesObrasParadas,
    consultaPrestadoresServicosEmpresasTerceirizadas,
    consultaObras,
})
